import { host } from "../../host";

export const apiFindUserByFace = `${host}supervisor/findUserByFace`